// SEO landing pages (config-driven). Each entry renders via pages/Landing.jsx.
// Keyed by slug (no leading slash). Content per language (nl default, en).

const APK_IMG = "https://customer-assets-cm19k8pv.emergentagent.net/job_7970d5b6-c425-46e1-a2d1-1ad428fd4f8b/artifacts/qgw721me_IMG_3906.webp";
const ONDERHOUD_IMG = "https://customer-assets-cm19k8pv.emergentagent.net/job_7970d5b6-c425-46e1-a2d1-1ad428fd4f8b/artifacts/hjkeri56_IMG_3911.webp";
const MECH_IMG = "https://customer-assets.emergentagent.com/job_arnhem-occasions/artifacts/k5z0tu5t_IMG_3145.jpeg";
const BRAKE_IMG = "https://customer-assets.emergentagent.com/job_arnhem-occasions/artifacts/fp7nq5z3_IMG_3147.jpeg";
const IMPORT_IMG = "https://customer-assets.emergentagent.com/job_arnhem-occasions/artifacts/ddzccw6i_bmw-x5-xdrive45e-high-executive-m-sport-f35420_d50fedae581809d83f1a682020a414b3.jpg";
const GARAGE_IMG = "https://customer-assets.emergentagent.com/job_arnhem-occasions/artifacts/4slgmqc0_IMG_3143.jpeg";

const AREAS = "Arnhem, Velp, Oosterbeek, Westervoort, Duiven, Huissen, Elst en Zevenaar";
const AREAS_EN = "Arnhem, Velp, Oosterbeek, Westervoort, Duiven, Huissen, Elst and Zevenaar";

export const LANDING = {
  "apk-arnhem": {
    icon: "clipboard",
    img: APK_IMG,
    serviceType: "APK-keuring",
    nl: {
      metaTitle: "APK Arnhem — APK-keuring vanaf €59,95 | MP Autobedrijf",
      metaDesc: "APK-keuring nodig in Arnhem? Bij MP Autobedrijf in Arnhem Noord bent u snel klaar. Vakkundige APK, eerlijk advies en direct kleine reparaties. Plan online uw APK.",
      eyebrow: "APK-keuring Arnhem",
      h1: "APK in Arnhem",
      accent: "zonder gedoe",
      intro: "Uw auto APK laten keuren in Arnhem? Bij MP Autobedrijf in Arnhem Noord keuren wij snel, vakkundig en eerlijk. Klein onderhoud combineren we graag met de APK, zodat u maar één keer hoeft te komen.",
      priceNote: "APK-keuring vanaf €59,95 — €39 in combinatie met een onderhoudsbeurt.",
      bullets: [
        "Officiële APK-keuring voor personenauto's en bestelwagens",
        "Direct advies over eventuele reparaties — geen verrassingen",
        "APK combineren met onderhoud bespaart u tijd en geld",
        "Herkeuring en kleine reparaties vaak dezelfde dag",
      ],
      faqs: [
        { q: "Hoelang duurt een APK-keuring?", a: "Een APK duurt gemiddeld 30 tot 60 minuten. U kunt wachten of uw auto later ophalen — u ontvangt van ons een bevestiging." },
        { q: "Wat kost een APK bij MP Autobedrijf?", a: "Een APK-keuring is vanaf €59,95. In combinatie met een onderhoudsbeurt betaalt u slechts €39 voor de APK." },
        { q: "Kan ik online een APK-afspraak maken?", a: "Ja. Kies via onze afspraakpagina de dienst APK, een datum en tijd. U ontvangt direct een bevestiging per e-mail." },
      ],
    },
    en: {
      metaTitle: "MOT (APK) Arnhem — from €59.95 | MP Autobedrijf",
      metaDesc: "Need an MOT (APK) in Arnhem? At MP Autobedrijf in Arnhem North you're done quickly. Expert inspection, honest advice and on-the-spot minor repairs. Book online.",
      eyebrow: "MOT / APK Arnhem",
      h1: "MOT in Arnhem",
      accent: "hassle-free",
      intro: "Need your car's MOT (APK) in Arnhem? At MP Autobedrijf in Arnhem North we inspect fast, expertly and honestly. We happily combine minor maintenance with your MOT so you only have to visit once.",
      priceNote: "MOT (APK) from €59.95 — €39 combined with a maintenance service.",
      bullets: [
        "Official MOT inspection for cars and vans",
        "Immediate advice on any repairs — no surprises",
        "Combine MOT with maintenance to save time and money",
        "Re-inspection and minor repairs often same day",
      ],
      faqs: [
        { q: "How long does an MOT take?", a: "An MOT takes 30 to 60 minutes on average. You can wait or collect your car later — you'll receive a confirmation." },
        { q: "What does an MOT cost?", a: "An MOT starts at €59.95. Combined with a maintenance service the MOT is only €39." },
        { q: "Can I book an MOT online?", a: "Yes. Choose the MOT service, a date and time on our booking page. You'll receive an instant email confirmation." },
      ],
    },
  },

  "onderhoud-arnhem": {
    icon: "wrench",
    img: ONDERHOUD_IMG,
    serviceType: "Auto onderhoud",
    nl: {
      metaTitle: "Auto onderhoud Arnhem — onderhoudsbeurt vanaf €149 | MP Autobedrijf",
      metaDesc: "Onderhoud voor uw auto in Arnhem Noord. Groot & klein onderhoud, olie verversen en reparaties door VW-, Audi-, BMW- en Mercedes-specialist. Plan online uw beurt.",
      eyebrow: "Auto onderhoud Arnhem",
      h1: "Onderhoud & reparatie",
      accent: "in Arnhem",
      intro: "Betrouwbaar onderhoud voor uw auto in Arnhem Noord. Van olie verversen en filters tot distributieriem en storingsdiagnose — bij MP Autobedrijf houden we uw auto veilig op de weg, met behoud van fabrieksgarantie.",
      priceNote: "Onderhoudsbeurt vanaf €149 — inclusief controle en advies.",
      bullets: [
        "Groot & klein onderhoud volgens fabrieksschema",
        "Specialist in Volkswagen, Audi, BMW, Mercedes en DSG",
        "Onderhoud met behoud van fabrieksgarantie",
        "Eerlijke prijzen en heldere uitleg vooraf",
      ],
      faqs: [
        { q: "Behoud ik mijn fabrieksgarantie?", a: "Ja. Wij onderhouden volgens het fabrieksschema, zodat uw fabrieks- of merkgarantie behouden blijft." },
        { q: "Wanneer is mijn auto toe aan onderhoud?", a: "Meestal op basis van kilometerstand of tijd volgens het onderhoudsschema. Twijfelt u? Wij adviseren u graag." },
        { q: "Wat kost een onderhoudsbeurt?", a: "Een onderhoudsbeurt is vanaf €149. Het exacte bedrag hangt af van uw auto en de benodigde onderdelen." },
      ],
    },
    en: {
      metaTitle: "Car maintenance Arnhem — service from €149 | MP Autobedrijf",
      metaDesc: "Reliable car maintenance in Arnhem North. Major & minor service, oil changes and repairs by VW, Audi, BMW & Mercedes specialist. Book your service online.",
      eyebrow: "Car maintenance Arnhem",
      h1: "Maintenance & repair",
      accent: "in Arnhem",
      intro: "Reliable maintenance for your car in Arnhem North. From oil changes and filters to timing belts and fault diagnosis — MP Autobedrijf keeps your car safe on the road while preserving manufacturer warranty.",
      priceNote: "Maintenance service from €149 — including inspection and advice.",
      bullets: [
        "Major & minor service to manufacturer schedule",
        "Specialist in Volkswagen, Audi, BMW, Mercedes and DSG",
        "Maintenance preserving your manufacturer warranty",
        "Fair prices and clear explanation up front",
      ],
      faqs: [
        { q: "Do I keep my manufacturer warranty?", a: "Yes. We service to the manufacturer schedule so your warranty is preserved." },
        { q: "When does my car need a service?", a: "Usually based on mileage or time per the maintenance schedule. Not sure? We're happy to advise." },
        { q: "What does a service cost?", a: "A maintenance service starts at €149. The exact amount depends on your car and required parts." },
      ],
    },
  },

  "airco-service-arnhem": {
    icon: "snowflake",
    img: MECH_IMG,
    serviceType: "Airco service",
    nl: {
      metaTitle: "Airco service Arnhem — aircocheck & vullen vanaf €79 | MP Autobedrijf",
      metaDesc: "Airco laten vullen of controleren in Arnhem? MP Autobedrijf verzorgt aircoservice, lekcontrole en desinfectie. Weer een koele auto in de zomer. Plan uw aircobeurt.",
      eyebrow: "Airco service Arnhem",
      h1: "Aircoservice",
      accent: "in Arnhem",
      intro: "Blaast uw airco niet meer koud? Bij MP Autobedrijf in Arnhem Noord verzorgen wij een complete aircoservice: bijvullen, lekcontrole en desinfectie tegen vieze luchtjes. Zo rijdt u weer aangenaam koel.",
      priceNote: "Aircoservice vanaf €79 — inclusief controle en bijvullen.",
      bullets: [
        "Airco bijvullen (R134a en R1234yf)",
        "Lekcontrole en drukmeting van het systeem",
        "Desinfectie tegen bacteriën en vieze luchtjes",
        "Advies bij verminderde koeling of storing",
      ],
      faqs: [
        { q: "Hoe vaak moet mijn airco worden onderhouden?", a: "Wij adviseren elke 2 jaar een aircoservice. Het systeem verliest jaarlijks koudemiddel, waardoor de koeling afneemt." },
        { q: "Wat kost een aircoservice?", a: "Een aircoservice is vanaf €79. Bij een lekkage of defect onderdeel geven wij eerst een heldere prijsopgave." },
        { q: "Ruikt mijn airco muf?", a: "Dan is desinfectie aan te raden. Wij reinigen het systeem zodat vieze luchtjes en bacteriën verdwijnen." },
      ],
    },
    en: {
      metaTitle: "Air conditioning service Arnhem — from €79 | MP Autobedrijf",
      metaDesc: "Air-con refill or check in Arnhem? MP Autobedrijf provides A/C service, leak checks and disinfection. Enjoy a cool car again. Book your air-con service.",
      eyebrow: "Air conditioning Arnhem",
      h1: "Air-con service",
      accent: "in Arnhem",
      intro: "Air conditioning no longer blowing cold? At MP Autobedrijf in Arnhem North we provide a complete A/C service: refill, leak check and disinfection against bad smells. Enjoy a pleasantly cool drive again.",
      priceNote: "Air-con service from €79 — including check and refill.",
      bullets: [
        "A/C refill (R134a and R1234yf)",
        "Leak check and system pressure test",
        "Disinfection against bacteria and bad smells",
        "Advice on reduced cooling or faults",
      ],
      faqs: [
        { q: "How often should A/C be serviced?", a: "We recommend an A/C service every 2 years. The system loses refrigerant yearly, reducing cooling." },
        { q: "What does an A/C service cost?", a: "An A/C service starts at €79. For a leak or faulty part we provide a clear quote first." },
        { q: "Does my A/C smell musty?", a: "Then disinfection is recommended. We clean the system so bad smells and bacteria disappear." },
      ],
    },
  },

  "auto-import-arnhem": {
    icon: "globe",
    img: IMPORT_IMG,
    serviceType: "Auto import",
    nl: {
      metaTitle: "Auto import Arnhem — uw droomauto uit Europa | MP Autobedrijf",
      metaDesc: "Auto importeren via MP Autobedrijf Arnhem. Wij zoeken, keuren en importeren uw droomauto uit Duitsland en Europa, inclusief BPM en RDW-registratie. Vraag advies.",
      eyebrow: "Auto import Arnhem",
      h1: "Auto import",
      accent: "op maat",
      intro: "Op zoek naar een specifieke auto? MP Autobedrijf in Arnhem regelt de complete import uit Duitsland en Europa. Van zoeken en keuren tot BPM, transport en RDW-registratie — u rijdt zorgeloos weg.",
      priceNote: "Importservice op maat — vraag een vrijblijvend voorstel aan.",
      bullets: [
        "Gerichte zoektocht naar uw droomauto in Europa",
        "Technische keuring en historiecontrole vooraf",
        "Volledige afhandeling BPM, transport en RDW",
        "Transparant advies over kosten en levertijd",
      ],
      faqs: [
        { q: "Uit welke landen importeren jullie?", a: "Voornamelijk uit Duitsland, maar ook uit andere Europese landen. We zoeken gericht naar de beste auto voor u." },
        { q: "Regelen jullie de BPM en RDW-registratie?", a: "Ja, wij verzorgen de volledige afhandeling: BPM-aangifte, transport en RDW-registratie. U rijdt met Nederlands kenteken weg." },
        { q: "Wat kost auto importeren?", a: "Dat hangt af van de auto en het land. Wij maken vooraf een transparant kostenoverzicht zodat u niet voor verrassingen komt te staan." },
      ],
    },
    en: {
      metaTitle: "Car import Arnhem — your dream car from Europe | MP Autobedrijf",
      metaDesc: "Import a car via MP Autobedrijf Arnhem. We find, inspect and import your dream car from Germany and Europe, including tax and registration. Ask for advice.",
      eyebrow: "Car import Arnhem",
      h1: "Car import",
      accent: "tailored",
      intro: "Looking for a specific car? MP Autobedrijf in Arnhem arranges the complete import from Germany and Europe. From sourcing and inspection to import tax, transport and registration — you drive away worry-free.",
      priceNote: "Tailored import service — request a no-obligation proposal.",
      bullets: [
        "Targeted search for your dream car in Europe",
        "Technical inspection and history check up front",
        "Full handling of import tax, transport and registration",
        "Transparent advice on costs and lead time",
      ],
      faqs: [
        { q: "Which countries do you import from?", a: "Mainly Germany, but also other European countries. We search specifically for the best car for you." },
        { q: "Do you handle tax and registration?", a: "Yes, we handle everything: import tax, transport and registration. You drive away with Dutch plates." },
        { q: "What does importing a car cost?", a: "It depends on the car and country. We provide a transparent cost overview up front so there are no surprises." },
      ],
    },
  },

  "dsg-specialist-arnhem": {
    icon: "cog",
    img: GARAGE_IMG,
    serviceType: "DSG onderhoud",
    nl: {
      metaTitle: "DSG specialist Arnhem — DSG onderhoud & olie verversen | MP Autobedrijf",
      metaDesc: "DSG-versnellingsbak onderhoud in Arnhem. MP Autobedrijf is DSG-specialist: olie & filter verversen, schokkende bak verhelpen en storingsdiagnose. Plan uw DSG-beurt.",
      eyebrow: "DSG specialist Arnhem",
      h1: "DSG specialist",
      accent: "in Arnhem",
      intro: "Schokt of trilt uw DSG-automaat? MP Autobedrijf in Arnhem Noord is DSG-specialist. Wij verversen olie en filter, stellen de bak opnieuw af en verhelpen storingen — zodat u weer soepel schakelt.",
      priceNote: "DSG onderhoud op maat — vraag naar de mogelijkheden voor uw model.",
      bullets: [
        "DSG olie & filter verversen (nat en droog)",
        "Verhelpen van schokken, trillen of doorslippen",
        "Storingsdiagnose met professionele apparatuur",
        "Advies over onderhoudsinterval van uw DSG",
      ],
      faqs: [
        { q: "Hoe vaak moet DSG-olie worden ververst?", a: "Meestal elke 60.000 km voor een natte DSG. Wij adviseren u op basis van uw model en rijgedrag." },
        { q: "Mijn DSG schokt bij het optrekken — wat nu?", a: "Vaak helpt een olie- en filterservice met heradaptatie. Bij aanhoudende klachten stellen wij een diagnose." },
        { q: "Zijn jullie echt DSG-specialist?", a: "Ja. Wij hebben de kennis en apparatuur voor onderhoud en diagnose van DSG-versnellingsbakken." },
      ],
    },
    en: {
      metaTitle: "DSG specialist Arnhem — DSG service & oil change | MP Autobedrijf",
      metaDesc: "DSG gearbox service in Arnhem. MP Autobedrijf is a DSG specialist: oil & filter change, fixing jerky shifting and fault diagnosis. Book your DSG service.",
      eyebrow: "DSG specialist Arnhem",
      h1: "DSG specialist",
      accent: "in Arnhem",
      intro: "Is your DSG automatic jerking or shuddering? MP Autobedrijf in Arnhem North is a DSG specialist. We change oil and filter, re-adapt the gearbox and fix faults — so you shift smoothly again.",
      priceNote: "Tailored DSG service — ask about the options for your model.",
      bullets: [
        "DSG oil & filter change (wet and dry clutch)",
        "Fixing jerking, shuddering or slipping",
        "Fault diagnosis with professional equipment",
        "Advice on your DSG maintenance interval",
      ],
      faqs: [
        { q: "How often should DSG oil be changed?", a: "Usually every 60,000 km for a wet DSG. We advise based on your model and driving." },
        { q: "My DSG jerks when pulling away — what now?", a: "Often an oil and filter service with re-adaptation helps. For persistent issues we run a diagnosis." },
        { q: "Are you really a DSG specialist?", a: "Yes. We have the knowledge and equipment for DSG gearbox service and diagnosis." },
      ],
    },
  },

  "remmen-vervangen-arnhem": {
    icon: "disc",
    img: BRAKE_IMG,
    serviceType: "Remmen vervangen",
    nl: {
      metaTitle: "Remmen vervangen Arnhem — remblokken & schijven vanaf €149 | MP Autobedrijf",
      metaDesc: "Remmen vervangen in Arnhem? MP Autobedrijf vervangt remblokken en remschijven, controleert remvloeistof en handrem. Veilig remmen tegen een eerlijke prijs. Plan online.",
      eyebrow: "Remmen Arnhem",
      h1: "Remmen vervangen",
      accent: "in Arnhem",
      intro: "Piepende of trillende remmen? Bij MP Autobedrijf in Arnhem Noord vervangen wij remblokken en remschijven, controleren we de remvloeistof en handrem. Zo remt u weer veilig — tegen een eerlijke prijs.",
      priceNote: "Remmen vervangen vanaf €149 per as — inclusief montage.",
      bullets: [
        "Remblokken en remschijven vervangen",
        "Controle van remvloeistof en remleidingen",
        "Onderzoek naar piepen, trillen of langere remweg",
        "Alleen kwaliteitsonderdelen, eerlijke prijs",
      ],
      faqs: [
        { q: "Wanneer moet ik mijn remmen vervangen?", a: "Bij piepen, trillen, een langere remweg of een waarschuwing op het dashboard. Wij controleren de remmen gratis bij twijfel." },
        { q: "Wat kost remmen vervangen?", a: "Remmen vervangen is vanaf €149 per as, inclusief montage. Het exacte bedrag hangt af van uw auto en onderdelen." },
        { q: "Hoelang duurt het vervangen van remmen?", a: "Meestal 90 tot 120 minuten per as. U kunt wachten of uw auto later ophalen." },
      ],
    },
    en: {
      metaTitle: "Brake replacement Arnhem — pads & discs from €149 | MP Autobedrijf",
      metaDesc: "Brake replacement in Arnhem? MP Autobedrijf replaces brake pads and discs, checks brake fluid and handbrake. Safe braking at a fair price. Book online.",
      eyebrow: "Brakes Arnhem",
      h1: "Brake replacement",
      accent: "in Arnhem",
      intro: "Squeaking or vibrating brakes? At MP Autobedrijf in Arnhem North we replace brake pads and discs, check brake fluid and the handbrake. So you brake safely again — at a fair price.",
      priceNote: "Brake replacement from €149 per axle — including fitting.",
      bullets: [
        "Replacing brake pads and discs",
        "Checking brake fluid and brake lines",
        "Investigating squeaking, vibration or longer braking distance",
        "Quality parts only, at a fair price",
      ],
      faqs: [
        { q: "When should I replace my brakes?", a: "When squeaking, vibrating, a longer braking distance or a dashboard warning appears. We check brakes free of charge when in doubt." },
        { q: "What does brake replacement cost?", a: "Brake replacement starts at €149 per axle, including fitting. The exact amount depends on your car and parts." },
        { q: "How long does it take?", a: "Usually 90 to 120 minutes per axle. You can wait or collect your car later." },
      ],
    },
  },
};

export const LANDING_SLUGS = Object.keys(LANDING);

export function landingMeta(slug, lang) {
  const p = LANDING[slug];
  if (!p) return null;
  const c = p[lang] || p.nl;
  return { t: c.metaTitle, d: c.metaDesc };
}

export const LANDING_AREAS = { nl: AREAS, en: AREAS_EN };
